import React, { type ReactElement, useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { campaign } from '../../constants';
import { ampliTrackMessageDisplayedEvent, MessageType } from '../../services/track.service';
import { aiAssistantContext } from '../../state/AIAssistantContextProvider';
import useScreenSize from '../../utils/useScreenSize';
import { MukiBudeOnboardingStep } from '../AIAssistant/Dialog/hooks/useMukiBudeOnboarding';
import RedesignOnboardingHint from './RedesignOnboardingHint';

const ImageGeneratorSideNavbarHint = ({ children }: { children: ReactElement }) => {
	const { t } = useTranslation();
	const { onboardingState, concludeOnboardingStep } = useContext(aiAssistantContext);
	const { isMdScreen, isLgScreen } = useScreenSize();
	// The hint is only shown on lg and md screens (AC5: hidden on sm/xs).
	const isMdOrLgScreen = isMdScreen || isLgScreen;

	const shouldShow = Boolean(
		isMdOrLgScreen && onboardingState?.[MukiBudeOnboardingStep.IMAGE_GENERATOR_HINT]?.shouldShow
	);

	const hasTrackedShowRef = useRef(false);
	useEffect(() => {
		if (shouldShow && !hasTrackedShowRef.current) {
			ampliTrackMessageDisplayedEvent(campaign.imageGeneratorTool, MessageType.HINT, 1);
			hasTrackedShowRef.current = true;
		}
		if (!shouldShow) {
			hasTrackedShowRef.current = false;
		}
	}, [shouldShow]);

	const onClose = () => concludeOnboardingStep(MukiBudeOnboardingStep.IMAGE_GENERATOR_HINT);

	return (
		<RedesignOnboardingHint
			title={t('Create images with AI')}
			description={t('In Mukibude you can now generate teaching images. Quick and ready to use.')}
			open={shouldShow}
			placement="right"
			onClose={onClose}
			isNew
		>
			{children}
		</RedesignOnboardingHint>
	);
};

export default ImageGeneratorSideNavbarHint;
